var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"con-vs-loading vs-loading-color-success"},[_c('div',{staticClass:"vs-loading default",staticStyle:{"transform":"scale(0.4)"}},[_c('div',{staticClass:"effect-1 effects"}),_c('div',{staticClass:"effect-2 effects"}),_c('div',{staticClass:"effect-3 effects"})])]),_vm._v("\n\n   \n")])
}]

export { render, staticRenderFns }